import { render } from "./AppButton.html?vue&type=template&id=44c7709e"
import script from "./AppButton.js?vue&type=script&lang=js"
export * from "./AppButton.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__